import React, { Component } from "react";
import { GET_LIST } from "admin-on-rest";
import { RestClient } from "../../restClient";
import { Create } from "admin-on-rest";
import { MarketersForm } from "../Create";
import { filter } from "lodash";
import IconTitle from "../../components/icon_title";
class MainCreate extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: false,
    };
  }

  componentWillMount() {
    this.setState({
      loading: true,
    });
    RestClient(GET_LIST, "marketers", {
      pagination: { page: 1, perPage: 1000 },
      sort: { field: "nickname", order: "ASC" },
      filter: {},
    })
      .then((items) => {
        if (items && items.data) {
          const newList = filter(items.data, function (oo) {
            return oo.nickname !== null;
          });
          // console.log(res);
          this.setState({
            list: newList,
            loading: false,
          });
        }
      })
      .catch((e) => {
        // resolve([]);
        this.setState({
          loading: false,
        });
      });
  }

  render() {
    if (this.state.loading) {
      return <div />;
    }
    return (
      <Create
        {...this.props}
        title={
          <IconTitle icon="marketers" title={"resources.marketers.title"} />
        }
      >
        <MarketersForm
          {...this.props}
          redirect="show"
          listMarketer={this.state.list}
        />
      </Create>
    );
  }
}

export default MainCreate;



// WEBPACK FOOTER //
// ./src/marketers/form/MainCreate.js